import { render, staticRenderFns } from "./step-three.vue?vue&type=template&id=1547a00b&scoped=true&"
import script from "./step-three.vue?vue&type=script&lang=js&"
export * from "./step-three.vue?vue&type=script&lang=js&"
import style0 from "./step-three.vue?vue&type=style&index=0&id=1547a00b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547a00b",
  null
  
)

export default component.exports